import { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Tooltip, useMapEvents } from "react-leaflet";
import L from "leaflet";
import { scoreTown } from "../lib/scoring.js";
import "leaflet/dist/leaflet.css";

const scoreColor = pct =>
  pct >= 75 ? "#1b7a4e" :
  pct >= 60 ? "#c8870a" : "#c94040";

function pillIcon(pct, name, selected) {
  const safe = String(name).replace(/</g, "&lt;");
  return L.divIcon({
    className: "map-pill-wrap",
    html:
      `<div class="map-pill${selected ? " is-sel" : ""}" style="--mp:${scoreColor(pct)}">` +
        `<span class="mp-score">${pct}</span>` +
        `<span class="mp-name">${safe}</span>` +
      `</div>`,
    iconSize: [0, 0],
  });
}

// Houdt de huidige kaartgrenzen bij + meldt of de gebruiker bewogen heeft.
function BoundsWatcher({ onMoved }) {
  useMapEvents({
    moveend: e => onMoved(e.target.getBounds()),
    zoomend: e => onMoved(e.target.getBounds()),
  });
  return null;
}

export function MapView({ towns, concelhoBySlug, weights, onOpenTown }) {
  const [isMobile, setIsMobile] = useState(false);
  const [selected, setSelected] = useState(null);
  const [pendingBounds, setPendingBounds] = useState(null); // gebied veranderd, nog niet toegepast
  const [areaFilter, setAreaFilter]       = useState(null); // toegepaste grenzen
  useEffect(() => {
    const check = () => setIsMobile(window.matchMedia("(pointer: coarse)").matches);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!towns?.length) return null;

  let scored = towns
    .map(t => ({ t, pct: Math.round(scoreTown(t, weights, concelhoBySlug?.[t.concelho]).pct) }))
    .filter(({ t }) => t.coords);

  if (areaFilter) {
    scored = scored.filter(({ t }) => areaFilter.contains(L.latLng(t.coords)));
  }
  scored = scored.sort((a, b) => a.pct - b.pct);

  const showSearchHere = pendingBounds && !areaFilter;

  return (
    <div style={{ position:"absolute", inset:0 }}>
      <MapContainer
        center={[39.2, -8.8]}
        zoom={7}
        style={{ width:"100%", height:"100%" }}
        scrollWheelZoom={!isMobile}
        zoomControl={false}
        tap={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="© OpenStreetMap contributors"
        />
        <BoundsWatcher onMoved={b => { setPendingBounds(b); if (areaFilter) setAreaFilter(b); }} />
        {scored.map(({ t, pct }) => (
          <Marker
            key={t.name}
            position={t.coords}
            icon={pillIcon(pct, t.name, selected === t.name)}
            zIndexOffset={pct}
            eventHandlers={{
              click:     () => onOpenTown?.(t),
              mouseover: () => setSelected(t.name),
              mouseout:  () => setSelected(s => (s === t.name ? null : s)),
            }}
          >
            <Tooltip direction="top" offset={[0, -22]} opacity={0.95}>
              <strong>{t.name}</strong> — {t.region} · {pct}/100
            </Tooltip>
          </Marker>
        ))}
      </MapContainer>

    </div>
  );
}
